import { format, startOfDay } from 'date-fns';
import type { TipDetailDto } from '@/api/backoffice-schemas/tipDetailDto';

export type FeedState = {
  date: Date;
  page: number;
};

export type GetApiTipsParams = {
  PageNumber: number;
  PageSize: number;
  TipsterId?: string;
  Status: string;
  Date?: string;
};

export const createInitialFeedState = (
  type: 'finished' | 'not_started'
): FeedState => {
  return {
    date: startOfDay(new Date()),
    page: 1,
  };
};

export const buildTipsFeedQueryParams = (
  type: 'finished' | 'not_started',
  state: FeedState,
  tipsterId?: string
): GetApiTipsParams => {
  const baseParams: GetApiTipsParams = {
    PageNumber: state.page,
    PageSize: 5,
    TipsterId: tipsterId,
    Status: type,
  };

  if (type === 'not_started') {
    return {
      ...baseParams,
      Date: format(state.date, 'yyyy-MM-dd'),
    };
  }

  return baseParams;
};

export const shouldShowInitialLoading = (
  isLoading: boolean,
  type: 'finished' | 'not_started',
  itemsLength: number
): boolean => {
  if (!isLoading) return false;
  if (type === 'finished') {
    return itemsLength === 0;
  }
  return true;
};

export const getSkeletonCount = (type: 'finished' | 'not_started'): number => {
  return 5;
};

export const filterActiveTips = (tips: TipDetailDto[]): TipDetailDto[] => {
  return tips.filter((tip) => tip.match?.status !== 'finished');
};
